import classnames from 'classnames';

import { ReactComponent as UserCenterIcon } from 'img/sideBar/user-center.svg';
import { ReactComponent as WalletIcon } from 'img/sideBar/wallet.svg';
import { ReactComponent as ChatIcon } from 'img/sideBar/chat.svg';
import { ReactComponent as SaleIcon } from 'img/sideBar/sale.svg';
import { ReactComponent as ArrowRightIcon } from 'img/sideBar/arrow-right.svg';

import './index.css';
import { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const IconButton = ({ icon, text, onClick }) => {
  const handleClick = () => {
    onClick?.();
  };

  return (
    <div className="iconButtonContainer" onClick={handleClick}>
      {icon}
      <span className="iconButtonText">{text}</span>
    </div>
  );
};

const SideBar = () => {
  const { t } = useTranslation();

  const buttons = [
    {
      key: 'userCenter',
      icon: <UserCenterIcon />,
      text: t('SideBar.button_userCenter'),
      onClick: () => {
        console.log('user-center');
      },
    },
    {
      key: 'wallet',
      icon: <WalletIcon />,
      text: t('SideBar.button_wallet'),
      onClick: () => {
        console.log('wallet');
      },
    },
    {
      key: 'chat',
      icon: <ChatIcon />,
      text: t('SideBar.button_chat'),
      onClick: () => {
        console.log('chat');
      },
    },
    {
      key: 'sale',
      icon: <SaleIcon />,
      text: t('SideBar.button_sale'),
      onClick: () => {
        console.log('sale');
      },
    },
  ];
  const [collapsed, setCollapsed] = useState(false);

  const classNames = classnames('collapseIcon', {
    rotated: collapsed,
  });

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="sideBar-wrapper">
      <Collapse in={!collapsed}>
        <div className="sideBar-container">
          {buttons.map(button => (
            <IconButton {...button} />
          ))}
        </div>
      </Collapse>
      <ArrowRightIcon className={classNames} onClick={handleCollapse} />
    </div>
  );
};

export default SideBar;
